module.exports = __webpack_public_path__ + "img/preacher-mentor-4.73f3c791.svg";